import { useEffect, useState } from 'react';
import AllotmentsHotelSelector from './Partials/AllotmentsHotelSelector';
import AllotmentsEditor from './Partials/AllotmentsEditor';
import { useSearchParams } from '../../hooks';
import { formatHotelResult } from './Partials/allotmentsUtils';
import { getHotel } from 'api/node/hotels';
import { useAsync } from 'react-async';
import { KoobListPageLayout } from '@koob/ui';
import FilterHotels from 'components/FilterHotels';
import LocationAwareSearch from 'components/LocationAwareSearch';
import { Container } from 'ui';

export default function Allotments() {
  const [searchParams] = useSearchParams();
  const hotelId = searchParams?.hotelId;

  const [hotel, setHotel] = useState(null);

  const { data: hotelData } = useAsync({
    promiseFn: getHotel,
    hotelId,
  });

  useEffect(() => {
    if (hotelData) {
      setHotel(formatHotelResult(hotelData.data));
    }
  }, [hotelData]);

  return (
    <Container variant="main" size="full">
      <KoobListPageLayout
        width="wide"
        search={<LocationAwareSearch name="search" />}
        filters={<FilterHotels />}
      >
        <div className="pb-16 flex-col space-y-5">
          <AllotmentsHotelSelector
            hotel={hotel}
            setHotel={setHotel}
            kind="allotments"
          />

          {hotel && <AllotmentsEditor hotel={hotel} />}
        </div>
      </KoobListPageLayout>
    </Container>
  );
}
